import React from 'react'
import '../../_metronic/partials/MapComponents/MapDetail.css'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'
import {
  ChartsWidget1,
  TablesWidget1,
  ListsWidget5,
  TablesWidget5,
} from '../../_metronic/partials/widgets'
import {useParams} from 'react-router-dom'
import tutorial from '../../_metronic/assets/images/tutorial.jpg'
import upload from '../../_metronic/assets/images/upload.png'

const MapDetail = () => {
  const {detail} = useParams()

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Map Details Page</h3>
          </div>

          <Link to='/map/tutorial-island/edit-page' className='btn btn-primary align-self-center'>
            {/* Link değişecek */}
            Edit
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>Tutorial Island</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Description</label>

            <div className='col-lg-8 fv-row'>
              <p className='fw-semibold text-dark h6'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique dicta, nisi esse
                mollitia dolore et. Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Similique dicta, nisi esse mollitia dolore et. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Similique dicta, nisi esse mollitia dolore et.
              </p>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Capacity</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>100 Person</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Url</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <p className='fw-semibold text-dark h6'>Map Url Link</p>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Event Type</label>

            <div className='col-lg-8'>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <label htmlFor=''>Convert</label>
                <label htmlFor=''>Meeting</label>
                <label htmlFor=''>Party</label>
              </div>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Map Images</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MapDetail
